import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { fetchCaptcha } from '@/lib/api';
import type { CaptchaParams } from '@/types/captcha';
export const useCaptcha = (params, t0) => {
  const $ = _c(7);
  const enabled = t0 === undefined ? true : t0;
  let t1;
  let t2;
  if ($[0] !== params) {
    t1 = ["captcha", params];
    t2 = () => fetchCaptcha(params);
    $[0] = params;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== enabled || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t1,
      queryFn: t2,
      enabled,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      staleTime: Infinity
    };
    $[3] = enabled;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return useQuery(t3);
};
export default useCaptcha;